import { render, staticRenderFns } from "./CommunityNFTStaking.vue?vue&type=template&id=12c2cc78&scoped=true&"
import script from "./CommunityNFTStaking.vue?vue&type=script&lang=js&"
export * from "./CommunityNFTStaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2cc78",
  null
  
)

export default component.exports